import React from 'react';

import { PERMISSION } from 'src/features/auth';

import type { User } from 'src/features/auth';

type AuthContextType = {
    user: User | null;
    permissions: PERMISSION[];
    permissionsLoaded: boolean;
};

const AuthContext = React.createContext<AuthContextType>({
    user: null,
    permissions: [],
    permissionsLoaded: true,
});

export default AuthContext;
